import React from "react";
import { styled, withStyle } from "baseui";
import { Button, SHAPE, KIND, SIZE } from "baseui/button";
import Blank from "baseui/icon/blank";

const MainHeaderGroupContainer = styled("div", ({ $theme }) => ({
  display: "flex",
  flexDirection: "row",
  marginLeft: "auto",
}));

export default function HeaderButtonGroup({ buttons }) {
  return (
    <MainHeaderGroupContainer>
      {buttons.map((item) => (
        <Button
          overrides={{
            BaseButton: {
              style: ({ $theme }) => ({
                margin: "0px 10px",
              }),
            },
          }}
          key={item.label}
          disabled={item.style && item.style.disabled}
          shape={SHAPE.pill}
          size={SIZE.mini}
          kind={KIND.secondary}
          endEnhancer={() => <Blank size={5} />}
          startEnhancer={<item.icon size={20} />}
          onClick={item.clickAction}
        >
          {item.label}
        </Button>
      ))}
    </MainHeaderGroupContainer>
  );
}
